import './App.css';
import {useEffect, useState} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Chat from "./Components/Chat";
import Login from "./Components/Login";
import styled from 'styled-components';
import Header from "./Components/Header";
import Sidebar from "./Components/Sidebar";
import db, { auth , provider } from './firebase'


function App() {
  // console.log("Start of appJS")

  const[rooms, setRooms]= useState([])  
  const[user, setUser] = useState(JSON.parse(localStorage.getItem('user'))  )




  // console.log("User state is  "+user);
  const getChannels = () =>{
      db.collection('rooms').onSnapshot((snapshot) => {      
        
        setRooms(snapshot.docs.map((doc)=>{
          return {id: doc.id, name:doc.data().name}
        }));
      })
  }

useEffect(()=>{
  
  getChannels();
},[])



const signOut = () => {
  // console.log("Remove the User");

  auth.signOut().then(()=>{
    localStorage.removeItem('user');
    setUser(null);

  })
}
  
// console.log("user in state "+ user.name);

  return (
          <div className="App">   
<Router>
  { 
   !user ?
    <Login setUser={setUser}/>
    :
  <Container>
    <Header signOut={signOut} user={user} />
    <Main>
      <Sidebar rooms={rooms}/>
    <Switch>
        <Route path="/room/:channelId">
            <Chat user={user}/>
        </Route>  
        <Route path="/">
            Select or Create Channel
        </Route>  
    </Switch>
    </Main>
  </Container>
  }
</Router>
          </div>
  );
}

export default App;

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display:grid;
  grid-template-rows: 38px minmax(0, 1fr);
  `;

const Main = styled.div`
  background: #FFFFFF;
  display: grid;
  grid-template-columns: 260px auto;
  `;